import { Routes, Route } from "react-router-dom";

import RetailOutlets from "./sections/RetailOutlets";
import Settings from "./sections/Settings";
import Signals from "./sections/Signals";
import Goods from "./sections/Goods";
import Access from "./sections/Access";

function TunderApp() {
  const data = JSON.parse(localStorage.getItem("userData") as string);

  return (
    <Routes>
      {!data.isCustomer && (
        <>
          <Route path="/shops" element={<RetailOutlets />} />
          <Route path="/properties" element={<Settings />} />
          <Route path="/signals" element={<Signals />} />
          <Route path="/goods" element={<Goods />} />
          <Route path="/access" element={<Access />} />
        </>
      )}
    </Routes>
  );
}

export default TunderApp;
